import React from 'react';
import { useHasUrgencySignalsEnabled } from './provider';

export const UrgencySignalsWrapper: React.FC = ({ children }) => {
    const hasUrgencySignalsEnabled = useHasUrgencySignalsEnabled();

    return hasUrgencySignalsEnabled ? <>{children}</> : <></>;
};
